import type { PmsConnectionSummary } from "../../types/config";
import type { Translations } from "../../i18n/en";

/**
 * Returns a human-readable label for a PMS connection.
 * Prefers the explicit connection name; falls back to the provider's localized
 * display name (from `t.pms.providers.<providerType>.displayName`); finally falls back to "PMS".
 */
export function getConnectionLabel(
    conn: Pick<PmsConnectionSummary, "name" | "providerType">,
    t: Translations,
): string {
    if (conn.name && conn.name.trim().length > 0) return conn.name;
    const providers = (t.pms as { providers?: Record<string, { displayName?: string }> })?.providers;
    return providers?.[conn.providerType]?.displayName ?? "PMS";
}
